import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const AreaChart = ({ chartData }) => {

  // Ensure chartData is an array
  if (!Array.isArray(chartData)) {
    return <div>No data available</div>;
  }
  
  // Transform data for Highcharts
  const categories = chartData.map((item) => item.time); // Just use the entire time string as it is
  const dataPoints = chartData.map((item) => item.count); // Extract counts

  const options = {
    chart: {
      type: "area",
    },
    title: {
      text: "",
    },
    xAxis: {
      categories: categories, // Use raw time data
      title: {
        text: "Time",
      },
    },
    yAxis: {
      title: {
        text: "Count",
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "Performance",
        data: dataPoints, // Use API data
        color: {
          linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
          stops: [
            [0, "#31A05F"], // Dark green
            [1, "#FFFFFF"], // White
          ],
        },
      },
    ],
  };

  return (
    <div className="chart-container">
      <HighchartsReact highcharts={Highcharts} options={options} style={{ width: "100%" }} />
    </div>
  );
};

export default AreaChart;
